import PropTypes from 'prop-types';

import { iso8601DateStr, uuid } from './generic';

/**
 * A system notification.
 */
export const notificationShape = PropTypes.shape({
  content: PropTypes.string.isRequired,
  expiry_time: iso8601DateStr.isRequired,
  id: uuid.isRequired,
  occurrence_time: iso8601DateStr.isRequired,
  status: PropTypes.oneOf(['new', 'have_seen']).isRequired,
  tag: PropTypes.string.isRequired,
  target: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['notification', 'alert']).isRequired,
});
